var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'user-detail',
  created () {
    var today = new Date()
    today.setMonth(today.getMonth() + 2)
    this.afterTwoMonth = new Date(today.getFullYear(), today.getMonth(), 1)

    this.search()
  },
  data () {
    return {
      canValidate: true,
      types: [],
      strCount: 0,
      afterTwoMonth: null,
      userover: {
        user_overday: null,
        user_turnover_type_id: null,
        user_turnover_class: null,
        user_turnover_remarks: null
      },
      errorMsgFlag: true
    }
  },
  computed: {
    user () {
      return this.$store.getters.userDetail
    },
    turnover_types () {
      return this.$store.getters.turnoverDetail
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    validation: function() {
      var v = {
        user_overday: !!this.userover.user_overday,
        user_overday_range: this.userover.user_overday < this.afterTwoMonth,
        user_turnover_class: !!this.userover.user_turnover_class,
        user_turnover_type_id: !!this.userover.user_turnover_type_id,

        not_input: !!this.userover.user_overday &&
                   this.userover.user_overday < this.afterTwoMonth &&
                   !!this.userover.user_turnover_class &&
                   !!this.userover.user_turnover_type_id
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goShopLists: function () {
      utils.backClear()
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    goUsers: function () {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goBackList: function () {
      this.$router.push({ path: sessionStorage.getItem("BackPage"), query: { type: this.$router.currentRoute.query.type } })
    },
    search: function() {
      var self = this
      var data = {}
      var callback
      callback = function() {
      }
      this.$store.dispatch('USER_DETAIL',  {id: this.$route.params.id, data: data, callback: callback})
    },
    onClickSave: function () {
      var data = {}
      var self = this
      self.canValidate = true
      if (this.isValid) {
        this.errorMsgFlag = false
        this.userover.user_overday = this.userover.user_overday.getFullYear() + '-' + ("0" + (this.userover.user_overday.getMonth() + 1)).slice(-2) + '-' + ("0" + this.userover.user_overday.getDate()).slice(-2)
        data = self.userover
        this.$store.dispatch('USEROVER_UPDATE', { data: data, callback: this.onSaved, user_id: self.$route.params.id })
      } else {
        console.log("need edit");
      }
    },
    onSaved: function (result) {
      this.$router.push('/users')
    },
    strCounter: function () {
      this.half()
      this.strCount = this.userover.user_turnover_remarks.length
    },
    selectedUserType: function() {
      var self = this
      self.userover.user_turnover_type_id = null
      self.types = []
      for(var i=0; i < self.$store.getters.turnoverDetail.length; i++){
        var turnover_type = self.$store.getters.turnoverDetail[i]
        if (turnover_type.attributes['turnover-class'] == self.userover.user_turnover_class) {
          self.types.push(turnover_type)
        }
      }
    },
    half: function () {
      this.userover.user_turnover_remarks = utils.emHalf(this.userover.user_turnover_remarks)
    },
    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img = document.getElementById('imageModalImg')
      var text = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + self.timeStamp
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/user-over.js